import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { AgreementsStore } from './AgreementsReducer.types';

// @ts-ignore
export const initialState: AgreementsStore = Immutable.fromJS({
  terms: '',
  showTerms: false,
  isFetching: false,
});

const AgreementsReducer = handleActions<any>(
  {
    AGREEMENTS_REQUEST: (state: AgreementsStore) => state.set('isFetching', true),

    AGREEMENTS_RESPONSE_FAILURE: (state: AgreementsStore) =>
      state.set('isFetching', false).set('showTerms', true).set('terms', 'Not Implemented'),

    AGREEMENTS_RESPONSE: (state: AgreementsStore) => state.set('isFetching', false).set('showTerms', true),

    CLEAR_AGREEMENTS: () => initialState,
    AUTHENTICATION_LOGOUT: () => initialState,
  },
  initialState
);

export default AgreementsReducer;
